import { render, staticRenderFns } from "./RequestVerificationText.vue?vue&type=template&id=7d166aae&scoped=true&"
import script from "./RequestVerificationText.vue?vue&type=script&lang=js&"
export * from "./RequestVerificationText.vue?vue&type=script&lang=js&"
import style0 from "./RequestVerificationText.vue?vue&type=style&index=0&id=7d166aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d166aae",
  null
  
)

export default component.exports